// src/Components/DashboardRoute.jsx
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';

export default function DashboardRoute() {
  const [role, setRole] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    setRole(user?.role || null);
  }, []);

  if (!role) return null; // wait for role to load

  return role === 'admin' ? <Dashboard /> : <Navigate to="/transactions" />;
}
